/*
	Generated on 10/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router";
import {
  Button,
  Form,
  SelectionField,
  MultiSelectionField,
  InputField,
  MultiSelectField,
  RadioInputField,
  TextAreaField,
  RichTextField,
  VisualizationAttr,
  Spinner,
  
  
} from "@/commons/components";
import {
  ALLOWED_PERMISSIONS,
  findAllowedPermission,
} from "@/commons/constants/allowedPermission";
import cleanFormData from "@/commons/utils/cleanFormData";

import { notifyError, notifySuccess} from "@/commons/utils/toaster";
import * as Layouts from "@/commons/layouts";

const FormFilterSemester = ({ 
	semesterList
	,  setDaftarPenggunaanRuanganParams
 }) => {
  const { 
    control, 
    handleSubmit,
  } = useForm()
  
  
  
  
  const navigate = useNavigate()
  
  const filter = (data) => {
    const cleanData = cleanFormData(data)
    setDaftarPenggunaanRuanganParams({
  		...(cleanData.semesterId !== "undefined" && { semesterId: cleanData.semesterId }),
    })
  }
  
  
  return (
	<div>
	  <Layouts.FormComponentLayout
		  title="Filter Semester" 
		  onSubmit={handleSubmit(filter)}
	
	    vas={[
		  ]}
	
		  formFields={[
		  
	
		  
		  <Controller
		    key="semesterId"
	        name="semesterId"
	        control={control}
			rules={{ required: "Harap pilih filter by semester" }} 
	        render={({ field, fieldState }) => (
					<SelectionField
				
	            label="Filter By Semester"
	            options={semesterList}
				optionKey="semesterId"
	            optionLabel="semester"
	            placeholder="Masukkan filter by semester"
					fieldState={fieldState}
	            {...field}
					isRequired={true}
	          />
	
	        )}
	      />
		  ]}
	
		  itemsEvents={[
				<Button id="_2Fkk8C2AEfCiIOe1nt4Q7w" key="Filter" type="submit" variant="primary">Filter</Button>
	    ]}
	  />
	    
	</div>
  )
}

export default FormFilterSemester
